import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * Breadcrumbs serve as an effective visual aid, indicating the location of the user within the website’s hierarchy
 * levels.
 *
 * @slot - Holds the wb-breadcrumb elements
 */
@Component({
  tag: 'wb-breadcrumbs',
  styleUrl: 'breadcrumbs.scss',
  shadow: true,
})
export class BreadcrumbsComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * Colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  public render(): JSX.Element {
    return (
      <Host class="wb-breadcrumbs" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <slot />
      </Host>
    );
  }
}
